import { render, staticRenderFns } from "./CardSummaryList.vue?vue&type=template&id=64d62d69&scoped=true"
import script from "./CardSummaryList.vue?vue&type=script&lang=js"
export * from "./CardSummaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d62d69",
  null
  
)

export default component.exports